import { makeStyles, tokens } from '@fluentui/react-components';

export const useTimePickerStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalXS,
    // Allow the wrapped Fluent Combobox (TimePicker is a combobox) to shrink
    // below its default min-inline-size when placed in a narrow grid cell.
    minWidth: 0,
    '& .fui-Combobox': {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    '& .fui-Combobox__input': {
      minWidth: 0,
    },
  },
  listbox: {
    height: '340px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '& [role="option"][aria-selected="false"] svg': {
      opacity: 0,
    },
    '& [role="option"][aria-selected="true"] svg': {
      opacity: 1,
    },
  },
});
